module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "title": "Beginner"
    }
  }, [_c('div', {
    staticClass: "titlepage"
  }, [_c('div', [_c('div', [_c('h1', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "d0e98",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Beginner")])]), _c('a', {
    attrs: {
      "id": "d0e98",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  })]), _c('a', {
    attrs: {
      "id": "d0e98",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  })]), _c('a', {
    attrs: {
      "id": "d0e98",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  })]), _c('a', {
    attrs: {
      "id": "d0e98",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Image of a fence."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Beginner",
      "src": "images/IMG_2176.jpg"
    }
  })])]), _c('h2', {
    staticClass: "nodivide"
  }, [_c('a', {
    attrs: {
      "id": "d0e98",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e106",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Breads")])]), _c('a', {
    attrs: {
      "id": "d0e106",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('h3', {
    staticClass: "nodivide"
  }, [_c('a', {
    attrs: {
      "id": "d0e106",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e108",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Pizza Pull-A-Parts ")])]), _c('a', {
    attrs: {
      "id": "d0e108",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('div', {
    staticClass: "itemizedlist"
  }, [_c('ul', {
    staticClass: "itemizedlist"
  }, [_c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("12-inch Dutch oven ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("32 hot coals ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("10–12 servings ")])])])]), _vm._v(" "), _c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("1 envelope (1.3 ounces) dry onion soup mix ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 cup grated Parmesan cheese ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 envelope (1.3 ounces) dry Italian dressing mix, divided ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Dough for 1 loaf of bread, frozen bread, thawed, or 2 cans (16.3 ounces each)\n            refrigerator biscuits ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("12 to 15 pepperoni slices, cut into small pieces ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("6 ounces pizza sauce ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/2 cup butter, melted ")])])])]), _vm._v(" "), _c('p', [_vm._v("Thoroughly grease Dutch oven and warm over 6–8 coals. ")]), _vm._v(" "), _c('p', [_vm._v("Combine soup mix, cheese, and 2 tablespoons dressing mix in a large ziplock bag. Cut dough\n        into 1-inch pieces and drop into bag. Gently toss to coat pieces in the seasoning mixture. ")]), _vm._v(" "), _c('p', [_vm._v("In a large bowl, carefully mix dough, pepperoni, and pizza sauce together and then spoon\n        dough mixture into the Dutch oven. Sprinkle remaining dressing mix on top of this mixture\n        and pour butter on top of that. Cover and bake, using 8 coals underneath the oven and 16 on\n        top, for approximately 20 minutes. Bread should be browned on the top when done. ")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Image of a pitchfork."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Beginner",
      "src": "images/IMG_2082.jpg"
    }
  })])]), _c('h3', [_c('a', {
    attrs: {
      "id": "d0e108",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e146",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Corn Bread ")])]), _c('a', {
    attrs: {
      "id": "d0e146",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('div', {
    staticClass: "itemizedlist"
  }, [_c('ul', {
    staticClass: "itemizedlist"
  }, [_c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("12-inch Dutch oven ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("24 hot coals ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("6–8 servings ")])])])]), _vm._v(" "), _c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("1-1/2 cups corn meal ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/2 cup flour ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 teaspoons baking powder ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 teaspoons sugar ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 teaspoon salt ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/2 teaspoon baking soda ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/4 cup butter, softened ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1-1/2 cups buttermilk ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 eggs ")])])])]), _vm._v(" "), _c('p', [_vm._v("Mix together all ingredients, beating well for 30 seconds. Pour into greased Dutch oven,\n        cover, and bake, using 8 coals underneath the oven and 16 on top, for 30–35 minutes or until\n        corn bread is golden brown. ")]), _vm._v(" "), _c('p', [_vm._v("Variations: You may substitute bacon drippings for the butter and add crumbled cooked bacon\n        to the batter. Chopped onions and bell peppers cooked in the butter or bacon fat make a\n        spicy corn bread. ")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e146",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e181",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Sides")])]), _c('a', {
    attrs: {
      "id": "d0e181",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('h3', [_c('a', {
    attrs: {
      "id": "d0e181",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e183",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("5-Bean Baked Beans ")])]), _c('a', {
    attrs: {
      "id": "d0e183",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('div', {
    staticClass: "itemizedlist"
  }, [_c('ul', {
    staticClass: "itemizedlist"
  }, [_c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("12-inch Dutch oven ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("39 hot coals ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("15–20 servings ")])])])]), _vm._v(" "), _c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("1 pound ground sausage ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 pound bacon, cut into 1-inch pieces ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 onion, diced ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 cup catsup ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 tablespoons vinegar ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3/4 cup molasses ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 teaspoon salt ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1-1/4 cups brown sugar ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 tablespoons prepared mustard ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 can (15 ounces) kidney beans ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 can (15 ounces) pinto beans ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 can (15 ounces) black beans ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 can (15 ounces) pork and beans ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 can (15 ounces) hominy ")])])])]), _vm._v(" "), _c('p', [_vm._v("In Dutch oven, cook sausage, bacon, and onion until onion is translucent over 12 coals.\n        Drain off most of the drippings. Add all other ingredients to Dutch oven and combine. ")]), _vm._v(" "), _c('p', [_vm._v("Cover and bake, using 9 coals underneath the oven and 16–18 on top, for 60 minutes. ")])]), _c('h3', [_c('a', {
    attrs: {
      "id": "d0e183",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e228",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Cowpoke Beans ")])]), _c('a', {
    attrs: {
      "id": "d0e228",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('div', {
    staticClass: "itemizedlist"
  }, [_c('ul', {
    staticClass: "itemizedlist"
  }, [_c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("10-inch Dutch oven ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("26 hot coals ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("6 servings ")])])])]), _vm._v(" "), _c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("6 strips bacon ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/2 medium onion, finely chopped ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 cans (14.5 ounces each) cut green beans, drained ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/4 teaspoon garlic powder ")])])])]), _vm._v(" "), _c('p', [_vm._v("Fry bacon in Dutch oven over 12 coals, then remove from oven and crumble. Sauté onions in\n        bacon drippings until translucent. Remove onions and take out all but 1 tablespoon of fat.\n        Place beans in oven and heat for a couple of minutes. Add bacon, onions, and garlic powder\n        and combine. Cover and bake, using 6 coals underneath the oven and 8 on top, for 12 minutes. ")]), _vm._v(" "), _c('p', [_vm._v("Variations: You may add bell peppers, chopped and cooked with onions, or top with\n        French-fried onions and/or grated cheese of choice. ")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Image of a horse."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Beginner",
      "src": "images/IMG_2012.jpg"
    }
  })])]), _c('h3', [_c('a', {
    attrs: {
      "id": "d0e228",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e258",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Vegetable Medley ")])]), _c('a', {
    attrs: {
      "id": "d0e258",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('div', {
    staticClass: "itemizedlist"
  }, [_c('ul', {
    staticClass: "itemizedlist"
  }, [_c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("12-inch Dutch oven ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("39 hot coals ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("12–14 servings ")])])])]), _vm._v(" "), _c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("4 to 5 thick strips bacon ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 large onion, thinly sliced ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 cups diagonally sliced carrots ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 cup diagonally sliced celery ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 cups broccoli florets ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 cups cauliflower florets ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("12 to 14 new red potatoes, quartered ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 tablespoons vegetable oil ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 envelope (1.3 ounces) dry onion soup mix ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 can (10.75 ounces) cream of mushroom soup, condensed ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Water ")])])])]), _vm._v(" "), _c('p', [_vm._v("Cook bacon in Dutch oven over 12 coals, remove, and dice. Place all vegetables and oil into\n        the Dutch oven; stir to coat. Add dry soup mix and bacon and stir. In a small bowl, combine\n        soup with three-fourths can of water and then pour over vegetables. ")]), _vm._v(" "), _c('p', [_vm._v("Cover and bake, using 9 coals underneath the oven and 18 on top, for 40 minutes. Using a\n        large spoon, gently turn over the vegetables once or twice while cooking, do not stir. ")]), _vm._v(" "), _c('p', [_vm._v(" You may add grated cheese of choice on the top of the vegetables once they are done. ")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Image of the recipe above."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Beginner",
      "src": "images/IMG_1449.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e258",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e304",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Main Courses")])]), _c('a', {
    attrs: {
      "id": "d0e304",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('h3', [_c('a', {
    attrs: {
      "id": "d0e304",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e306",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Omelet ")])]), _c('a', {
    attrs: {
      "id": "d0e306",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('div', {
    staticClass: "itemizedlist"
  }, [_c('ul', {
    staticClass: "itemizedlist"
  }, [_c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("12-inch Dutch oven ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("31 hot coals ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("8–10 servings ")])])])]), _vm._v(" "), _c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("2 tablespoons butter ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 medium onions, chopped ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 cup chopped green bell pepper ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 cups sliced mushrooms ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 cups diced ham ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("12 eggs ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1-1/2 cups milk ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 teaspoon baking soda ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 cup grated cheese, of choice ")])])])]), _vm._v(" "), _c('p', [_vm._v("Melt butter in Dutch oven over 6 coals. Cook onions, bell pepper, and mushrooms until the\n        onions appear translucent. Add ham and cook 2 minutes. ")]), _vm._v(" "), _c('p', [_vm._v("In a large bowl, beat eggs, milk, and baking soda. Pour egg mixture over vegetables and top\n        with cheese. Cover and bake, using 9 coals underneath the oven and 16 on top, for 20–25\n        minutes. Serve immediately. ")])]), _c('h3', [_c('a', {
    attrs: {
      "id": "d0e306",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e341",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Lasagna ")])]), _c('a', {
    attrs: {
      "id": "d0e341",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('div', {
    staticClass: "itemizedlist"
  }, [_c('ul', {
    staticClass: "itemizedlist"
  }, [_c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("12-inch Dutch oven ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("38 hot coals ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("12–14 servings ")])])])]), _vm._v(" "), _c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("1-1/2 pounds ground beef ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Salt and pepper, to taste ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("4 cups pasta sauce of choice ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 package (16 ounces) wide lasagna noodles, uncooked ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3 cups grated Italian blend or mozzarella cheese ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("16 ounces cottage or ricotta cheese ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("4 cups water ")])])])]), _vm._v(" "), _c('p', [_vm._v("Brown the beef in the Dutch oven over 12 coals, drain fat, and then season with salt and\n        pepper. Remove meat from Dutch oven and wipe the oven clean. ")]), _vm._v(" "), _c('p', [_vm._v("Starting with sauce, layer sauce, noodles, meat, and cheeses in the oven. Continue layering\n        until ingredients are gone. End with last layer being sauce and grated cheese. Gently pour\n        the water around the edges of Dutch oven without disturbing layers. ")]), _vm._v(" "), _c('p', [_vm._v("Cover and bake, using 9 coals underneath the oven and 17 on top, for 40–50 minutes or until\n        noodles are tender. ")])]), _c('h3', [_c('a', {
    attrs: {
      "id": "d0e341",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e374",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Chicken and Rice ")])]), _c('a', {
    attrs: {
      "id": "d0e374",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('div', {
    staticClass: "itemizedlist"
  }, [_c('ul', {
    staticClass: "itemizedlist"
  }, [_c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("12-inch Dutch oven ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("38 hot coals ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("6–8 servings ")])])])]), _vm._v(" "), _c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("1 whole chicken, cut into pieces ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Seasoning salt, to taste ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3/4 cup vegetable oil ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 cups uncooked rice ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 can (10.75 ounces) cream of chicken soup, condensed ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3 cups water ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1-1/2 cups grated cheese, of choice ")])])])]), _vm._v(" "), _c('p', [_vm._v("Remove skin from chicken pieces and season meat with seasoning salt. Heat oil in Dutch oven\n        over 12 coals and brown chicken. Remove chicken from Dutch oven and drain oil. Place rice,\n        soup, and water in Dutch oven and mix. Place chicken in last. ")]), _vm._v(" "), _c('p', [_vm._v("Cover and bake, using 9 coals underneath the oven and 17 on top, for 40 minutes. Uncover,\n        sprinkle cheese over chicken and rice and cook 5 minutes more. ")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Image of a fence."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Beginner",
      "src": "images/IMG_2188.jpg"
    }
  })])]), _c('h3', [_c('a', {
    attrs: {
      "id": "d0e374",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e410",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Dutch Oven Chicken ")])]), _c('a', {
    attrs: {
      "id": "d0e410",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('div', {
    staticClass: "itemizedlist"
  }, [_c('ul', {
    staticClass: "itemizedlist"
  }, [_c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("12-inch Dutch oven ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("38 hot coals ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("6–8 servings ")])])])]), _vm._v(" "), _c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("1 whole chicken, cut into pieces ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 cups buttermilk ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3/4 cup vegetable oil ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 cup breading, mix your own or use a prepared mix* ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 cup water ")])])])]), _vm._v(" "), _c('p', [_vm._v("Clean and skin chicken pieces, place in buttermilk, and let sit 30 minutes or overnight. ")]), _vm._v(" "), _c('p', [_vm._v("Heat oil in Dutch oven over 12 coals. Dip chicken pieces in breading mixture and brown in\n        oil. Remove chicken pieces as they are browned and drain off oil. Return to Dutch oven and\n        add water. ")]), _vm._v(" "), _c('p', [_vm._v("Cover and bake, using 9 coals underneath the oven and 17 coals on top, for 60 minutes. ")]), _vm._v(" "), _c('p', [_vm._v("*I prefer Dixie Fry brand. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e410",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('strong', [_vm._v("Note:")])]), _vm._v(" This chicken goes great with ")]), _c('span', {
    staticClass: "link",
    attrs: {
      "href": "#/ch03#potatoes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dutch Oven\n          Potatoes.")])]), _vm._v(" "), _c('h3', [_c('a', {
    attrs: {
      "id": "d0e448",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Southwest Chicken ")])]), _c('a', {
    attrs: {
      "id": "d0e448",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('div', {
    staticClass: "itemizedlist"
  }, [_c('ul', {
    staticClass: "itemizedlist"
  }, [_c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("12-inch deep Dutch oven ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("48 hot coals ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("6–8 servings ")])])])]), _vm._v(" "), _c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("1 tablespoon olive oil ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 whole chicken ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 teaspoon dried oregano ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/2 teaspoon cumin ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 lime, cut into wedges ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 sprig cilantro ")])])])]), _vm._v(" "), _c('p', [_vm._v("Brush oil onto the chicken. In a small bowl, crush the oregano and mix with cumin; sprinkle\n        over the chicken and rub in. Place the lime and cilantro into the body cavity. Twist the\n        wing tips under the chicken and tie the drumsticks together. ")]), _vm._v(" "), _c('p', [_vm._v("Place chicken in Dutch oven breast side up. Cover and bake, using 8 coals underneath the\n        oven and 16 on top, for 1-1/2–2 hours, replacing the coals after 50 minutes. A meat\n        thermometer will read 180 degrees F. when done. ")])]), _c('h3', [_c('a', {
    attrs: {
      "id": "d0e448",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e477",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Barbecue Ribs ")])]), _c('a', {
    attrs: {
      "id": "d0e477",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('div', {
    staticClass: "itemizedlist"
  }, [_c('ul', {
    staticClass: "itemizedlist"
  }, [_c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("12-inch Dutch oven ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("60 hot coals ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("10–12 servings ")])])])]), _vm._v(" "), _c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("6 pounds country-style pork ribs (beef ribs can be substituted) ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Salt and pepper, to taste ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 bottle (28 ounces) of strong barbecue sauce* ")])])])]), _vm._v(" "), _c('p', [_vm._v("Over 12 coals, slightly brown ribs in Dutch oven and season with salt and pepper. Cover\n        ribs with barbecue sauce. ")]), _vm._v(" "), _c('p', [_vm._v("Cover and bake, using 8 coals underneath the oven and 14–16 coals on top, for 1 1/2–2\n        hours. You will need to replace the coals with new ones after 50 minutes of cooking time. If\n        the sauce gets too thick during cooking, add a small amount of water to thin it. ")]), _vm._v(" "), _c('p', [_vm._v("*I prefer Bull’s-Eye brand. ")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Image of the recipe above."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Beginner",
      "src": "images/IMG_1573.jpg"
    }
  })])]), _c('h3', [_c('a', {
    attrs: {
      "id": "d0e477",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e507",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Dutch Oven Stew ")])]), _c('a', {
    attrs: {
      "id": "d0e507",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('div', {
    staticClass: "itemizedlist"
  }, [_c('ul', {
    staticClass: "itemizedlist"
  }, [_c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("12-inch Dutch oven ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("36 hot coals ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("8–10 servings ")])])])]), _vm._v(" "), _c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Vegetable oil ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 pound stew meat ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 medium onions, diced ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("5 potatoes, cut into bite-size pieces ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("4 carrots, cut into bite-size pieces ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3 ribs celery, cut into bite-size pieces ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3 beef bouillon cubes ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3 cans (10.75 ounces each) cream of mushroom soup, condensed ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Warm water ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 envelopes (.87 ounces each) brown gravy mix ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 tablespoons soy sauce ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Salt and pepper, to taste ")])])])]), _vm._v(" "), _c('p', [_vm._v("Heat 1/4-inch oil in the Dutch oven over 12 coals. Brown stew meat and onions. Drain off\n        oil. Add potatoes, carrots, and celery. Add bouillon cubes and soup plus enough warm water\n        to cover the vegetables. Stir in gravy mix and soy sauce; add salt and pepper. ")]), _vm._v(" "), _c('p', [_vm._v("Cover and bake, using 8 coals underneath the oven and 16 on top, stirring occasionally, for\n        1–1-1/2 hours or until the vegetables are cooked. ")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Image of a truck."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Beginner",
      "src": "images/IMG_2149.jpg"
    }
  })])]), _c('h3', [_c('a', {
    attrs: {
      "id": "d0e507",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e553",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Pot Roast ")])]), _c('a', {
    attrs: {
      "id": "d0e553",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('div', {
    staticClass: "itemizedlist"
  }, [_c('ul', {
    staticClass: "itemizedlist"
  }, [_c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("12-inch Dutch oven ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("60 hot coals ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("8–10 servings ")])])])]), _vm._v(" "), _c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("2 tablespoons vegetable oil ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 (3 to 4 pound) beef roast ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 bay leaf ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 teaspoon salt ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 teaspoon coarsely ground pepper ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("5 carrots, diagonally sliced ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 large onion, sliced ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 stalks celery, thinly sliced ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 cup beef broth ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 cups water, divided ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("6 potatoes, peeled and quartered ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 tablespoon cornstarch ")])])])]), _vm._v(" "), _c('p', [_vm._v("Heat Dutch oven over 12 coals. Add oil and heat. Brown meat on all sides and then add bay\n        leaf, salt, pepper, carrots, onion, celery, broth, and 1 cup water. ")]), _vm._v(" "), _c('p', [_vm._v("Cover and bake, using 8 coals underneath the oven and 16 on top for 60 minutes. Add\n        potatoes, cover, replace all coals, and cook for another 60 minutes. Remove roast and\n        vegetables to a serving platter. Mix the cornstarch with remaining water and combine with\n        meat drippings to make gravy. ")])]), _c('h3', [_c('a', {
    attrs: {
      "id": "d0e553",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e594",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Tri-Tip Roast ")])]), _c('a', {
    attrs: {
      "id": "d0e594",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('div', {
    staticClass: "itemizedlist"
  }, [_c('ul', {
    staticClass: "itemizedlist"
  }, [_c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("12-inch Dutch oven ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("66 hot coals ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("4–6 servings ")])])])]), _vm._v(" "), _c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("1 (2 pound) tri-tip roast ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 tablespoons beef bouillon granules ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 cups beef broth ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/2 teaspoon celery salt ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1-1/2 teaspoons minced onion ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/2 teaspoon garlic powder ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/4 teaspoon pepper ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/4 teaspoon basil ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 cups new baby potatoes, cut into bite-size pieces ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 cup baby carrots ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 cup button mushrooms ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 tablespoon corn starch ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 cup water ")])])])]), _vm._v(" "), _c('p', [_vm._v("Place roast in a Dutch oven. Dissolve bouillon in broth and pour over meat. In a small\n        bowl, mix seasonings and then rub into the roast. ")]), _vm._v(" "), _c('p', [_vm._v("Cover and bake, using 10 coals underneath the oven and 12 coals on top, for 2 hours.\n        Replace coals after 50 minutes. Add potatoes, carrots, and mushrooms, replace the coals\n        again, and cook for an additional 60 minutes. ")]), _vm._v(" "), _c('p', [_vm._v("Remove roast and vegetables to a serving platter. Mix the cornstarch with water and combine\n        with meat drippings to make gravy. ")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e594",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e639",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Desserts")])]), _c('a', {
    attrs: {
      "id": "d0e639",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('h3', [_c('a', {
    attrs: {
      "id": "d0e639",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e641",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Easy Cobbler ")])]), _c('a', {
    attrs: {
      "id": "d0e641",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('div', {
    staticClass: "itemizedlist"
  }, [_c('ul', {
    staticClass: "itemizedlist"
  }, [_c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("12-inch Dutch oven ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("24 hot coals ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("8–10 servings ")])])])]), _vm._v(" "), _c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("1 yellow or white cake mix ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/3 cup butter, melted ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1-1/4 cups milk ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3 eggs ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 can (21 ounces) pie filling, flavor of choice ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Whipped topping ")])])])]), _vm._v(" "), _c('p', [_vm._v("Follow directions on cake mix package, replacing water with milk and oil with butter. Mix\n        cake as directed on box. ")]), _vm._v(" "), _c('p', [_vm._v("Place a circle of parchment paper in bottom of Dutch oven. Put pie filling on paper and\n        gently spoon cake mix over filling. ")]), _vm._v(" "), _c('p', [_vm._v("Cover and bake, using 8 coals underneath the oven and 14–16 coals on top, for about 40\n        minutes. Test cake with a toothpick. If it comes out clean, it’s done. Let cake cool about\n        15 minutes and then turn out onto the Dutch oven lid. Carefully peel off the paper and serve\n        with whipped topping. ")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Image of a cabin."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Beginner",
      "src": "images/IMG_2118.jpg"
    }
  })])]), _c('h3', [_c('a', {
    attrs: {
      "id": "d0e641",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e677",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Apple Crisp ")])]), _c('a', {
    attrs: {
      "id": "d0e677",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('div', {
    staticClass: "itemizedlist"
  }, [_c('ul', {
    staticClass: "itemizedlist"
  }, [_c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("12-inch Dutch oven ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("24 hot coals ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("8–10 servings ")])])])]), _vm._v(" "), _c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("2 tablespoons lemon juice ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("8 cups sliced apples ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/2 cup sugar ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1-1/2 cups brown sugar ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 cup flour ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 cup oatmeal ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1-1/2 teaspoons cinnamon ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1-1/2 teaspoons nutmeg ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2/3 cup butter, softened ")])])])]), _vm._v(" "), _c('p', [_vm._v("In a large bowl, sprinkle juice over apples. Sprinkle sugar over the apples, tossing to\n        coat. Place apples in lightly greased Dutch oven. Using a medium bowl, mix brown sugar and\n        remaining ingredients together until crumbly. Sprinkle mixture evenly over the apples. ")]), _vm._v(" "), _c('p', [_vm._v("Cover and bake, using 10 coals underneath the oven and 14 on top, for 40 minutes or until\n        apples are cooked through. Let crisp sit 15 minutes uncovered to cool and set up. ")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Image of an old wheel."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Beginner",
      "src": "images/IMG_2219.jpg"
    }
  })])]), _c('h3', [_c('a', {
    attrs: {
      "id": "d0e677",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e717",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Zucchini Brownies ")])]), _c('a', {
    attrs: {
      "id": "d0e717",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('div', {
    staticClass: "itemizedlist"
  }, [_c('ul', {
    staticClass: "itemizedlist"
  }, [_c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("12-inch Dutch oven ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("27 hot coals ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("12–14 servings ")])])])]), _vm._v(" "), _c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("2 cups flour ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1-1/2 cups sugar ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/4 cup unsweetened cocoa ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 teaspoon salt ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3/4 teaspoon baking soda ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/2 cup vegetable oil ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 teaspoons vanilla ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 cups grated zucchini ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Powdered sugar ")])])])]), _vm._v(" "), _c('p', [_vm._v("In a large bowl, mix all dry ingredients. Add remaining ingredients, except for powdered\n        sugar, and stir to moisten. Place a disk of parchment paper covering the bottom of greased\n        Dutch oven and spoon batter onto paper. ")]), _vm._v(" "), _c('p', [_vm._v("Cover and bake, using 9 coals underneath the oven and 16–18 on the top, for 25–30 minutes.\n        Test brownies with a toothpick inserted in center. If it comes out clean, it’s done. Flip\n        onto a plate or Dutch oven lid and dust with powdered sugar. ")]), _vm._v(" "), _c('p', [_vm._v(" You may sprinkle nuts and/or chocolate chips on batter before baking. ")])]), _c('h3', [_c('a', {
    attrs: {
      "id": "d0e717",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e754",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Zucchini Cake ")])]), _c('a', {
    attrs: {
      "id": "d0e754",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('div', {
    staticClass: "itemizedlist"
  }, [_c('ul', {
    staticClass: "itemizedlist"
  }, [_c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("12-inch Dutch oven ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("27 hot coals ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("12–14 servings ")])])])]), _vm._v(" "), _c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("1 cup oil ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1-1/2 cups sugar ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 teaspoons vanilla ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3 eggs ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 teaspoon salt ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 teaspoon soda ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 teaspoons cinnamon ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 teaspoon nutmeg ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/2 teaspoon baking powder ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3 cups flour ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 cup chopped nuts ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 cups grated zucchini ")])])])]), _vm._v(" "), _c('p', [_vm._v("In a large bowl, thoroughly combine oil, sugar, vanilla, and eggs. Add dry ingredients and\n        mix only to moisten. Add nuts and zucchini; stir to combine. ")]), _vm._v(" "), _c('p', [_vm._v("Pour batter in well-greased Dutch oven. Cover and bake, using 9 coals underneath the oven\n        and 16–18 on top, for 45 minutes. Test cake with a toothpick. If it comes out clean, it’s\n        done. ")]), _vm._v(" "), _c('p', [_vm._v("Variations: You may add chocolate chips to batter or even frost this cake with cream cheese\n        frosting. ")])]), _c('h3', [_c('a', {
    attrs: {
      "id": "d0e754",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e797",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Coffee Cake ")])]), _c('a', {
    attrs: {
      "id": "d0e797",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('div', {
    staticClass: "itemizedlist"
  }, [_c('ul', {
    staticClass: "itemizedlist"
  }, [_c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("10-inch Dutch oven ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("17 hot coals ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("12–14 servings ")])])])]), _vm._v(" "), _c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("3/4 cup butter ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 cups sugar ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 eggs ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 teaspoon vanilla ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 cup sour cream ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 cups flour ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 teaspoon baking powder ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/2 teaspoon salt ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/2 cup chopped nuts, of choice ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/2 cup brown sugar ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 teaspoon cinnamon ")])])])]), _vm._v(" "), _c('p', [_vm._v("In a large bowl, cream together butter and sugar; add eggs one at a time, beating well. Add\n        vanilla and sour cream. Blend in flour, baking powder, and salt. Mix batter well. Pour half\n        of the batter into well-greased Dutch oven. Sprinkle with nuts, brown sugar, and cinnamon.\n        Add remaining batter, cover, and bake, using 7 coals underneath the oven and 9 –10 on top,\n        for 50 minutes. ")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Image of flowers."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Beginner",
      "src": "images/IMG_1927.jpg"
    }
  })])]), _c('h3', [_c('a', {
    attrs: {
      "id": "d0e797",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e839",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Pumpkin-Pie Cake ")])]), _c('a', {
    attrs: {
      "id": "d0e839",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('div', {
    staticClass: "itemizedlist"
  }, [_c('ul', {
    staticClass: "itemizedlist"
  }, [_c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("12-inch Dutch oven ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("29 hot coals ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("12–14 servings ")])])])])]), _c('h4', [_c('a', {
    attrs: {
      "id": "d0e839",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e851",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Crust ")])]), _c('a', {
    attrs: {
      "id": "d0e851",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("1 yellow cake mix (reserve 1 cup) ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 egg, beaten ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/2 cup butter, melted ")])])])])]), _c('h4', [_c('a', {
    attrs: {
      "id": "d0e851",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e860",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Filling ")])]), _c('a', {
    attrs: {
      "id": "d0e860",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("1 can (16 ounces) pumpkin ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 cup sugar ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/2 cup milk ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 eggs, beaten ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2-1/2 teaspoons pumpkin pie spice ")])])])])]), _c('h4', [_c('a', {
    attrs: {
      "id": "d0e860",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e873",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Topping ")])]), _c('a', {
    attrs: {
      "id": "d0e873",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("1 cup reserved cake mix ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/2 cup sugar ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/4 cup butter, softened ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Vanilla ice cream ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Whipped topping ")])])])]), _vm._v(" "), _c('p', [_vm._v("In a large bowl, combine crust ingredients and then pat into the bottom of greased Dutch\n        oven. In another large bowl, combine all filling ingredients and gently pour over the crust.\n        Using the same bowl the crust was made in, mix topping ingredients until crumbly and\n        sprinkle evenly over filling. ")]), _vm._v(" "), _c('p', [_vm._v("Cover and bake, using 9 coals underneath the oven and 18–20 on top, for 60 minutes. Serve\n        out of the Dutch oven with vanilla ice cream or whipped topping.")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Image of a river."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Beginner",
      "src": "images/IMG_1945.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "d0e873",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9495d9a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch02.vue
// module id = 75
// module chunks = 0